/*
 * IdentityCard.jsx (AbstractUser)
 *
 * Copyright © 2021 InstaLOD GmbH - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * This file and all its contents are proprietary and confidential.
 *
 * Maintained by Etienne Daher, 2021
 *
 * @file IdentityCard.js
 * @author Etienne Daher
 * @copyright 2021 InstaLOD GmbH. All rights reserved.
 * @section License
 */

import React from 'react';
import './IdentityCard.css';
import { Col, Row } from 'react-bootstrap';
import ImagePreview from './ImagePreview';
import { ProgressSpinner } from 'primereact/progressspinner';

import '../../cssLoader.css';
import { formatDate } from "@abstract/abstractwebcommon-shared/utils/sharedFunctions";
import EmailLink from './EmailLink';
import { copyValueHandler } from '../../../Shared/utils/sharedFunctions'
import Button from "react-bootstrap/Button";
import { ThemeMode } from '@abstract/abstractwebcommon-shared/enum/theme';


const renderData = (data, navigator, copyToClipboardSuccessHandler, isOpenUserDetailsOnClickEnabled, userDetailsLink) => {

  return (
    data &&
    data.map((eachData) => {
      if (eachData.value) {
        return (
          <div>
            {eachData.key !== 'Email' ? (
              <>
                <i
                  className={`${eachData.iconStyle} p-0`}
                  onClick={() => {
                    if (isOpenUserDetailsOnClickEnabled && userDetailsLink && userDetailsLink != '') {
                      window.location.href = userDetailsLink
                    }
                  }
                  }
                >
                  <span className='username'>{eachData.iconStyle ? ' ' : `${eachData.key}`} - {eachData.value}</span>
                </i>
                <i className="far fa-copy copy-icon" 
                  onClick={() => copyValueHandler(eachData.value, navigator, copyToClipboardSuccessHandler)} 
                />
              </>
            ) : (
              <EmailLink
                data={eachData}
                copyToClipboardSuccessHandler={copyToClipboardSuccessHandler} />
            )
            }
          </div>
        );
      } else {
        return <></>;
      }
    })
  );
};

const renderProfilePicture = (profilePicURL, firstName, lastName) => {
  if (profilePicURL) {
    return (
      <ImagePreview
        showInverted={false}
        showDelete={false}
        imageUrl={profilePicURL}
        isLogo={true}
        altText={''}
        imgClass={'profile mr-2'}
      />
    );
  } else {
    return (
      <div
        data-initials={`${firstName.charAt(0)}${lastName.charAt(
          0
        )}`}
      ></div>
    );
  }
};
const IdentityCard = ({
  firstName,
  lastName,
  profilePicURL,
  lastLogin,
  isLoading,
  data,
  navigator,
  isOpenUserDetailsOnClickEnabled, /**< boolean to open user details on user management page when username is clicked */
  userDetailsLink, /**< the link to the user management page with the userUUID embedded in it */
  showLegend = false,
  copyToClipboardSuccessHandler = () => { },
  isUserFound = true,
  onLogout = () => { } /**< Handle logout button click */,
  isShopPage = false
}) => {
  if (isLoading) {
    return <ProgressSpinner className="d-flex" />;
  }
  return (
    data && (
    <div className='example-warper'>
      <div className="card profile-card">
        <div className="card-body">
      { isUserFound ? (
        <>
      {
        showLegend ?
          <>
            <Row>
              <Col>
                <legend>Signed In:</legend>
              </Col>
              <Col>
                <div className="d-flex float-right">
                  <Button
                    className={`btn-block ${
                      isShopPage ? 'p-button p-button-primary' : ''
                    }`}
                    variant="primary" 
                    onClick={onLogout}
                  >
                    Logout
                  </Button>
                </div>
              </Col>
            </Row>
            <hr className="divider" />
          </>
          : <></>
      }
      {firstName && lastName && (
        <div className="d-flex align-items-center">
          <div>
            {renderProfilePicture(profilePicURL, firstName, lastName)}
          </div>
          <div className="my-auto">
            <h5 className="card-title mb-0">
              {firstName} {lastName}
            </h5>
          </div>
        </div>
      )}

      <div className="card-text">
        {firstName && lastName && !isShopPage && (
          <hr className="divider" />)}
        {renderData(data, navigator, copyToClipboardSuccessHandler, isOpenUserDetailsOnClickEnabled, userDetailsLink)}
        {lastLogin && (
          <>
            <hr className="divider" />
            <div  className="text-break last-login-label far">
              Last login - {formatDate(lastLogin, { isTime: true, isTwentyFour: true })}
            </div>
          </>
        )}
      </div>
      </>
      ) : (
        <EmailLink
        data={data}
        copyToClipboardSuccessHandler={copyToClipboardSuccessHandler} />
      )}
        </div>
      </div>
    </div>
    )
  );
};

export default IdentityCard;
